/* Routing helpers */

import { roles } from "../../../../index";
import { List } from "../pages/list/List";
import { CONTEXT } from "./ModuleHelpers";

export const ROUTE_PREFIX = "/" + CONTEXT;

export const ROUTES = {
  list: {
    path: `${ROUTE_PREFIX}`,
    component: List,
    accepts: [roles.client, roles.provider, roles.super_admin],
  },
};
export const ROUTE_DEFAULT = ROUTES.list.path;
